var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      width: 24,
      height: 24,
      opacity: 1
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4B4B4B;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0C114.615,0,0,114.612,0,256s114.615,256,256,256c141.384,0,256-114.612,256-256S397.384,0,256,0z  M281.479,412.736c-6.925,6.917-15.409,10.364-25.479,10.364c-10.066,0-18.562-3.545-25.476-10.661 c-6.913-7.306-10.364-15.703-10.364-25.174c0-9.875,3.45-18.264,10.364-25.181c6.913-6.902,15.409-10.372,25.476-10.372 c10.265,0,18.769,3.356,25.479,10.074c6.905,6.918,10.364,15.405,10.364,25.479C291.843,397.331,288.384,405.835,281.479,412.736z  M290.657,137.463L267.549,315c-0.789,7.314-4.636,10.976-11.549,10.976c-2.963,0-5.537-1.191-7.698-3.554 c-2.178-2.38-3.463-4.851-3.856-7.421l-23.107-177.537c-0.397-3.546-0.587-7.984-0.587-13.323c0-8.694,2.963-16.685,8.884-24.008 c5.926-7.496,14.703-11.24,26.364-11.24c11.256,0,19.946,3.654,26.07,10.959c6.125,7.314,9.178,15.397,9.178,24.289 C291.248,129.868,291.05,134.322,290.657,137.463z",
    style: {
      fill: "rgb(30, 48, 80)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.65ba1f3fb73e97f15bb4523f23bdd6c8.svg";
export { ForwardRef as ReactComponent };